import {useCallback, useEffect, useState} from "react";
import {AmiRepository} from "../repositories/AmiRepository";

// Enabled-only dialplan extensions for a project — backs the Start node's Web Call / Phone
// Call dialplan picker (disabled extensions aren't dialable, so they're filtered out here
// rather than left for the caller to filter).
export const useAmiActiveExtensions = (flowUid, active) => {
  const [extensions, setExtensions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const refetch = useCallback(() => {
    if (!flowUid) return;
    setLoading(true);
    setError(null);
    AmiRepository.listExtensions(flowUid)
      .then((response) => {
        const all = response?.data?.extensions || [];
        setExtensions(all.filter((ext) => ext?.enabled));
      })
      .catch((err) => {
        setError(err?.message || "Failed to load dialplans");
        setExtensions([]);
      })
      .finally(() => setLoading(false));
  }, [flowUid]);

  useEffect(() => {
    if (active) refetch();
  }, [active, refetch]);

  return {extensions, loading, error, refetch};
};
